<template>
  <div class="progress-bar" :style="{
                                      borderColor: borderColor,
                                      gridTemplateColumns: percentsString
                                    }">
    <div v-for="(p, i) of percentList" :key="i" :style="{backgroundColor: p.color}"></div>
  </div>
</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      borderColor: String,
      percentList: Array
    },
    computed: {
      percentsString() {
        return this.percentList.map(p => p.percent).join("% ") + "%";
      }
    }
  }
</script>

<style scoped>
  .progress-bar {
    display: grid;
    background-color: white;
    border-radius: 12px;
    height: 14px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    justify-content: start;
  }

  .progress-bar div:last-child {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue